import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP Error:', error);
      if (
        error.status === 401 ||
        (error.status === 400 && error.error?.detail === 'El token ha expirado')
      ) {
        authService.closeSession();
        return throwError(
          () => new Error('Su sesión ha expirado. Por favor, inicie sesión nuevamente.'),
        );
      }

      // Show error in modal
      //TEMP: deshabilitado temporalmente, cada proceso debe manejar su error de forma personalizada
      // const motivo_id = error.error?.motivo_id;
      // if (motivo_id) {
      //     const errorMessage = motivos[motivo_id as keyof typeof motivos] || 'Error desconocido';
      //     modalService.showError(errorMessage);
      // }

      return throwError(() => error);
    }),
  );
};
